import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Link, useNavigate, useParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { Paper, IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import CustomInput from "../../components/CustomInput";
import { ResetPasswordValidate } from "../../helper/Validation";
import { useForm } from "../../hooks/useForm";
import { useAlert } from "../../context/AlertContext";
import { LoadingButton } from "@mui/lab";
import Carousel from "react-material-ui-carousel";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import styles from "./styles";

const ResetPasswordPage = ({ handleResetPassword, loading, tokenInvalid }) => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      navigate("/dashboard");
    }
    if (tokenInvalid) {
      navigate("/");
    }
  }, [tokenInvalid]);

  const resetPasswordInitialData = {
    newPassword: {
      value: "",
      error: "",
    },
    confirmPassword: {
      value: "",
      error: "",
    },
  };

  const handleSubmit = async (data) => {
    // Validate passwords match
    if (data.newPassword.value !== data.confirmPassword.value) {
      return;
    }
    handleResetPassword(data, token);
  };

  const { state, handleChange, handleSubmit: formSubmit, handleFocus, disable } = useForm(
    resetPasswordInitialData,
    ResetPasswordValidate,
    handleSubmit,
  );

  const { newPassword, confirmPassword } = state;

  // Check if passwords match
  const passwordsMatch = newPassword.value && confirmPassword.value && newPassword.value === confirmPassword.value;
  const passwordMismatchError = newPassword.value && confirmPassword.value && newPassword.value !== confirmPassword.value;

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <Box sx={styles.main}>
      <Container sx={styles.root}>
        <Paper sx={styles.paper}>
          <Grid container sx={styles.gridContainer}>
            <Grid item xs={12} sm={12} md={6} sx={styles.gridItem}>
              <Box sx={styles.formContain}>
                <Typography variant="h4" sx={styles.mainheading}>
                  Reset Password
                </Typography>
                <Box sx={styles.headingborder}></Box>

                <form onSubmit={formSubmit} autoComplete="off">
                  <Box>
                    <Typography sx={styles.inputText}>New Password</Typography>
                    <Box sx={styles.passwordInputContainer}>
                      <CustomInput
                        name="newPassword"
                        type={showPassword ? "text" : "password"}
                        value={newPassword?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={newPassword?.error}
                      />
                    </Box>
                  </Box>

                  <Box sx={{ mt: 1 }}>
                    <Typography sx={styles.inputText}>Confirm Password</Typography>
                    <Box sx={styles.passwordInputContainer}>
                      <CustomInput
                        name="confirmPassword"
                        type={showConfirmPassword ? "text" : "password"}
                        value={confirmPassword?.value}
                        onChange={handleChange}
                        onFocus={handleFocus}
                        error={passwordMismatchError ? "Passwords do not match" : ""}
                      />
                    </Box>
                  </Box>

                  {passwordsMatch && (
                    <Typography sx={styles.successText}>
                      ✓ Passwords match
                    </Typography>
                  )}

                  <LoadingButton
                    loading={loading}
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={disable || !passwordsMatch}
                    sx={styles.submit}
                  >
                    Reset Password
                  </LoadingButton>
                </form>

                {/* <Box sx={styles.backToLoginContainer}>
                  <Link to="/" style={styles.backToLoginLink}>
                    <Typography sx={styles.backToLoginText}>
                      ← Back to Login
                    </Typography>
                  </Link>
                </Box> */}
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Carousel indicators={false}>
                <Box sx={styles.image}>
                  <Box sx={styles.backgroundImage}></Box>
                  <Typography sx={styles.sliderText}>
                    Securely reset your password using a verification link sent to your registered email address. Keep your account protected with a safe and reliable recovery process.
                  </Typography>
                  <Box sx={styles.dots}>
                    <Box sx={styles.dot2}></Box>
                    <Box sx={styles.dot1}></Box>
                  </Box>
                </Box>
                <Box sx={styles.image}>
                  <Box sx={styles.backgroundImage2}></Box>
                  <Typography sx={styles.sliderText}>
                    Regain access to your account quickly and securely. Follow the password reset link in your email to create a new password and continue using your account safely.
                  </Typography>
                  <Box sx={styles.dots}>
                    <Box sx={styles.dot1}></Box>
                    <Box sx={styles.dot2}></Box>
                  </Box>
                </Box>
              </Carousel>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default ResetPasswordPage;
